import request from '@/utils/request'

// 查询友情链接列表
export function listLink(query) {
  return request({
    url: '/ws/link/list',
    method: 'get',
    params: query
  })
}

